
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarBoard as ObiBuoyPilarBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-board.js';
 
 
 

 
 export const ObiBuoyPilarBoard = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-board',
   elementClass: ObiBuoyPilarBoardElement,
   events: {
     
   }
  });
 
 